export { default } from './ChatFooterIceBreakingTipsDesktop';
